/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { internalAuthCampingAxios } from 'ui-internal-camping/src/utils/internalCampingAxios';
import type { AvailabilityCampsite } from '../../../../types/camping';
import { campingAxios } from '../../utils/campingAxios';
import { urlWithParams } from '../../utils/utils';

export interface MonthlyAvailabilityResponse {
    campsites: Record<string, AvailabilityCampsite>;
}

export const MONTHLY_AVAILABILITY_KEY = 'monthly-availability';

export const monthlyAvailabilityKey = (
    campgroundId: string,
    month: string,
    isInternal: boolean
) => [MONTHLY_AVAILABILITY_KEY, campgroundId, month, isInternal] as const;

/**
 * Fetch a single month of campground availability. Errors are intentionally uncaught so
 * React Query's retry can see the status code (notably 429).
 */
export async function getMonthlyAvailability({
    campgroundId,
    month,
    isInternal,
    signal,
}: {
    campgroundId: string;
    month: string;
    isInternal: boolean;
    signal?: AbortSignal;
}): Promise<MonthlyAvailabilityResponse> {
    const axiosInstance = isInternal ? internalAuthCampingAxios : campingAxios;

    const response = await axiosInstance.get(
        urlWithParams(`/availability/campground/${campgroundId}/month`, {
            start_date: month,
        }),
        { signal }
    );

    return response.data;
}
